<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<h1 class="booktitle"><span class="brown">ice</span> <span class="brown1">cream</span> <span class="yellow">treats</span></h1>
<h4 class="subtitle"><a id="page_3"></a>easy ways to transform<br/>your favorite ice cream into<br/>spectacular desserts</h4>
<h3 class="author">charity ferreira</h3>
<p class="author2"><em><span class="blue">photographs by leigh beisch</span></em></p>
<p class="publogo"><img alt="Chronicle Books logo" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?4dab93bb